import { render, staticRenderFns } from "./AdminStatsAirlines.vue?vue&type=template&id=f1f7dfd8&"
import script from "./AdminStatsAirlines.vue?vue&type=script&lang=js&"
export * from "./AdminStatsAirlines.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports